(function () {
  var SELECTORS = [
    '.kl-hub-launcher',
    '[data-testid="hub-widget-container"]',
    '[class*="HubLauncherWidget"]',
    '[class*="HubWidgetContainer"]'
  ].join(', ');

  function hideKlaviyoHub(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTORS).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('opacity', '0', 'important');
    });
  }

  hideKlaviyoHub();

  if (typeof MutationObserver === 'undefined') return;

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(SELECTORS)) hideKlaviyoHub(node.parentElement || document);
        hideKlaviyoHub(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
